import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  CHAPTER_ADMIN_USER_CREATE,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  ROLE_LIST_DROPDOWN,
} from "../../../routes/routes";
import { toast } from "react-toastify";
import { CHAPTER_ADMIN_USER_CREATED } from "../../../constant/constant";
import { ValidationMessage, hasRole } from "../../../components/Utils";
import Select from "react-select";

const ChapterAdminUserCreate = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filter, setFilter] = useState([]);
  const [errors, setErrors] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [roleOptions, setRoleOptions] = useState({});
  const [type, setType] = useState("password");
  const [type1, setType1] = useState("password");

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  const auth_user = JSON.parse(localStorage.getItem("user"));

  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .post(CHAPTER_ADMIN_USER_CREATE, requestBody)
      .then((res) => {
        if (res.status === 201 && res.data.success) {
          toast.success(CHAPTER_ADMIN_USER_CREATED);
          navigate("/chapter-admin-users");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    if (hasRole([6])) {
      setForm({ ...form, country_id: auth_user?.country_id });
    }

    if (hasRole([7])) {
      setForm({
        ...form,
        country_id: auth_user?.country_id,
        state_id: auth_user?.state_id,
      });
    }

    if (hasRole([2])) {
      setForm({
        ...form,
        country_id: auth_user?.country_id,
        state_id: auth_user?.state_id,
        region_id: auth_user?.region_id,
      });
    }

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);

        // Fetch role data
        const roleResponse = await axios.get(ROLE_LIST_DROPDOWN);
        const fetchedRoleOptions = roleResponse.data.data;
        setRoleOptions(fetchedRoleOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [filter]);

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Chapter Admins</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/chapter-admin-users"}>
                    <span>Chapter Admin Users List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">
                    Create Chapter Admin User
                  </span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/chapter-admin-users"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Create User</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    {hasRole([1]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="country_id" className="form-label">
                            Country<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            options={countryOptions}
                            onChange={(selected) => {
                              handleStateClear();
                              setForm({
                                ...form,
                                country_id: selected?.value,
                                state_id: null,
                                region_id: null,
                                chapter_id: null,
                              });
                              setFilter({
                                ...filter,
                                country_id: selected?.value,
                                state_id: null,
                                region_id: null,
                                chapter_id: null,
                              });
                            }}
                          />
                          <ValidationMessage error={errors} name="country_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="state_id" className="form-label">
                            State<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            ref={selectStateRef}
                            options={stateOptions}
                            onChange={(selected) => {
                              handleRegionClear();
                              setForm({
                                ...form,
                                state_id: selected?.value,
                                region_id: null,
                                chapter_id: null,
                              });
                              setFilter({
                                ...filter,
                                state_id: selected?.value,
                                region_id: null,
                                chapter_id: null,
                              });
                            }}
                          />
                          <ValidationMessage error={errors} name="state_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6, 7]) && (
                      <div className="col-6 mb-3">
                        <label htmlFor="region_id" className="form-label">
                          Region<span className="text-danger">*</span>
                        </label>
                        <Select
                          isClearable
                          ref={selectRegionRef}
                          options={regionOptions}
                          onChange={(selected) => {
                            handleChapterClear();
                            setForm({
                              ...form,
                              region_id: selected?.value,
                              chapter_id: null,
                            });
                            setFilter({
                              ...filter,
                              region_id: selected?.value,
                              chapter_id: null,
                            });
                          }}
                        />
                        <ValidationMessage error={errors} name="region_id" />
                      </div>
                    )}

                    {hasRole([1, 6, 7, 2]) && (
                      <div className="col-6 mb-3">
                        <label htmlFor="chapter_id" className="form-label">
                          Chapter<span className="text-danger">*</span>
                        </label>
                        <Select
                          isClearable
                          ref={selectChapterRef}
                          options={chapterOptions}
                          onChange={(selected) => {
                            setForm({ ...form, chapter_id: selected?.value });
                            setFilter({
                              ...filter,
                              chapter_id: selected?.value,
                            });
                          }}
                        />
                        <ValidationMessage error={errors} name="chapter_id" />
                      </div>
                    )}

                    <div className="col-6 mb-3">
                      <label htmlFor="admin_role_id" className="form-label">
                        Admin Role<span className="text-danger">*</span>
                      </label>
                      <Select
                        options={roleOptions}
                        onChange={(selected) =>
                          setForm({
                            ...form,
                            admin_role_id: Number(selected?.value),
                          })
                        }
                      />
                      <ValidationMessage error={errors} name="admin_role_id" />
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="name">
                          Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Name"
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="name" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="email">
                          Email<span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Email"
                          onChange={(e) =>
                            setForm({ ...form, email: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="email" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="mobile_number">
                          Mobile Number<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control hide-arrow"
                          id="mobile_number"
                          placeholder="Mobile No"
                          onChange={(e) =>
                            setForm({ ...form, mobile_number: e.target.value })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="mobile_number"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="password">
                          Password<span className="text-danger">*</span>
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type={type}
                            className="form-control"
                            id="password"
                            placeholder="***********"
                            onChange={(e) =>
                              setForm({ ...form, password: e.target.value })
                            }
                          />
                          {type === "password" ? (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType("text")}
                            >
                              <i className="bx bx-hide"></i>
                            </span>
                          ) : (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType("password")}
                            >
                              <i className="bx bx-show"></i>
                            </span>
                          )}
                        </div>
                        <ValidationMessage error={errors} name="password" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="confirm_password"
                        >
                          Confirm Password<span className="text-danger">*</span>
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type={type1}
                            className="form-control"
                            id="confirm_password"
                            placeholder="***********"
                            onChange={(e) =>
                              setForm({
                                ...form,
                                confirm_password: e.target.value,
                              })
                            }
                          />
                          {type1 === "password" ? (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType1("text")}
                            >
                              <i className="bx bx-hide"></i>
                            </span>
                          ) : (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType1("password")}
                            >
                              <i className="bx bx-show"></i>
                            </span>
                          )}
                        </div>
                        <ValidationMessage
                          error={errors}
                          name="confirm_password"
                        />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/chapter-admin-users"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterAdminUserCreate;
